export enum DocumentInvolvedEntityType {
	Funding = 'Funding',
	Payment = 'Payment',
	CreditAssignment = 'CreditAssignment',
}
